// extracted by mini-css-extract-plugin
module.exports = {"description":"MPFat7OZ542OMsOuIl26","filters":"B6lwruJimyLSNggG4J7f","metadata":"BafhyqqW0yBd8joXJGzC","usageContainer":"PaKhwchofal8W7mx_921","heading":"jZ6KMePDNOq6LBBr9gjZ"};